"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rql_1 = require("../rql");
exports.WidgetType = rql_1.reverb_search_Filter_WidgetType;
function textFilter(options) {
    var paramName = options.paramName, paramValue = options.paramValue, name = options.name, widgetType = options.widgetType;
    var hasValue = !!paramValue;
    return {
        name: name,
        widgetType: widgetType || rql_1.reverb_search_Filter_WidgetType.TEXT,
        options: [
            {
                paramName: paramName,
                name: "\"" + (paramValue || '') + "\"",
                selected: hasValue,
                setValues: [paramValue],
                all: false,
            },
        ],
    };
}
exports.textFilter = textFilter;
function getRangeValue(filter, side) {
    var sideIdx = side === 'min' ? 0 : 1;
    var param = filter.options[sideIdx];
    return {
        key: param.paramName,
        value: param.setValues[0],
    };
}
exports.getRangeValue = getRangeValue;
function getRangeUnsetParams(filter) {
    var _a;
    var minSide = filter.options[0];
    var maxSide = filter.options[1];
    return _a = {},
        _a[minSide.paramName] = minSide.unsetValues,
        _a[maxSide.paramName] = maxSide.unsetValues,
        _a;
}
exports.getRangeUnsetParams = getRangeUnsetParams;
//# sourceMappingURL=search_filters.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/search_filters.js
// module id = ldvI
// module chunks = 0 1 2 3 4 9 10 14 20